export { default } from './KeyboardShortcutsPanel';
